

<template>
    <div class="pt-3 pl-5 pr-5">
        <div class="mb-2">
            <breadCrumb :routesArray="routesArray"></breadCrumb>
        </div>
        <div class="row w-full justify-between flex" style="align-items: center">
            <h1 class="title">Revised Risk</h1>
        </div>
        <div class="p-3 bg-white border border-lightgrey rounded mt-3">
            <div class='flex flex-col h-full'>
            <div class="flex-1 overflow-auto">
                <div class="statuscontainer p-2">
                    <div class="formcontainer flex flex-col">
                        <div class="impactLevel">
                            <h1 class="ml-2">Revised Impact</h1>
                            <div class="border-b border-solid mt-3 border-lightgrey"></div>
                            <div class="row flex flex-row w-full">
                                <div class="col-md-6 w-6/12 p-2">
                                    <label class="controllabel">Startegic</label>
                                    <!-- <select
                                        v-on:change="getMaxImpactValue()"
                                        class="inputboxstyling"
                                        v-model="riskObj.business"
                                    >
                                        <option value="" selected disabled hidden>Please select one</option>
                                        <option v-for="obj in dbBussiness" :key="obj" :value="obj.value">{{obj.key}}</option>
                                    </select> -->
                                    <Select
                                        v-model="riskObj.business"
                                        :options="dbBussiness"
                                        @change="getMaxImpactValue()"
                                        optionLabel="key"
                                        optionValue="value"
                                        placeholder="Please select one"
                                        class="custom-multiselect w-full"
                                    />
                                </div>
                                <div class="col-md-6 w-6/12 p-2">
                                    <label class="controllabel">Operation</label>
                                    <!-- <select
                                        v-on:change="getMaxImpactValue()"
                                        class="inputboxstyling"
                                        v-model="riskObj.operations"
                                    >
                                        <option value="" selected disabled hidden>Please select one</option>
                                        <option v-for="obj in dbOperations" :key="obj" :value="obj.value">{{obj.key}}</option>
                                    </select> -->
                                    <Select
                                        v-model="riskObj.operations"
                                        :options="dbOperations"
                                        @change="getMaxImpactValue()"
                                        optionLabel="key"
                                        optionValue="value"
                                        placeholder="Please select one"
                                        class="custom-multiselect w-full"
                                    />
                                </div>
                            </div>
                            <div class="row flex flex-row w-full">
                                <div class="col-md-6 w-6/12 p-2">
                                    <label class="controllabel">Compliance</label>
                                    <!-- <select
                                        v-on:change="getMaxImpactValue()"
                                        class="inputboxstyling"
                                        v-model="riskObj.legal"
                                    >
                                        <option value="" selected disabled hidden>Please select one</option>
                                        <option v-for="obj in dbLegal" :key="obj" :value="obj.value">{{obj.key}}</option>
                                    </select> -->
                                    <Select
                                        v-model="riskObj.legal"
                                        :options="dbLegal"
                                        @change="getMaxImpactValue()"
                                        optionLabel="key"
                                        optionValue="value"
                                        placeholder="Please select one"
                                        class="custom-multiselect w-full"
                                    />
                                </div>
                                <div class="col-md-6 w-6/12 p-2">
                                    <label class="controllabel">Financial</label>
                                    <!-- <select
                                        v-on:change="getMaxImpactValue()"
                                        class="inputboxstyling"
                                        v-model="riskObj.financial"
                                    >
                                        <option value="" selected disabled hidden>Please select one</option>
                                        <option v-for="obj in dbFinancial" :key="obj" :value="obj.value">{{obj.key}}</option>
                                    </select> -->
                                    <Select
                                        v-model="riskObj.financial"
                                        :options="dbFinancial"
                                        @change="getMaxImpactValue()"
                                        optionLabel="key"
                                        optionValue="value"
                                        placeholder="Please select one"
                                        class="custom-multiselect w-full"
                                    />
                                </div>
                            </div>
                            <div class="row flex flex-row w-full">
                                <div class="col-md-6 w-6/12 p-2">
                                    <label class="controllabel">Overall Impact</label>
                                    <!-- <select
                                        class="disabledinputboxstyling"
                                        disabled
                                        v-model="mainImpact"
                                        v-on:input="getMaxResidualRiskValue()"
                                    >
                                        <option value="" selected disabled hidden>Please select one</option>
                                        <option v-for="obj in dbSeverity" :key="obj" :value="obj.value">{{obj.key}}</option>
                                    </select> -->
                                    <Select
                                        v-model="mainImpact"
                                        disabled
                                        :options="dbSeverity"
                                        @change="getMaxResidualRiskValue()"
                                        optionLabel="key"
                                        optionValue="value"
                                        placeholder="Please select one"
                                        class="custom-multiselect w-full"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="likelihoodlevel mt-3">
                            <h1 class="ml-2">Revised Likelihood</h1>
                            <div class="border-b border-solid mt-3 border-lightgrey"></div>
                            <div class="row flex flex-row w-full">
                                <div class="col-md-6 w-6/12 p-2">
                                    <label class="controllabel">Revised Likelihood</label>
                                    <!-- <select
                                        v-on:change="getMaxResidualRiskValue()"
                                        class="inputboxstyling"
                                        v-model="riskObj.likelihood"
                                    >
                                        <option value="" selected disabled hidden>Please select one</option>
                                        <option v-for="obj in dbLikelihood" :key="obj" :value="obj.value">{{obj.key}}</option>
                                    </select> -->
                                    <Select
                                        v-model="riskObj.likelihood"
                                        :options="dbLikelihood"
                                        optionLabel="key"
                                        optionValue="value"
                                        placeholder="Please select one"
                                        class="custom-multiselect w-full"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="residualrisklevel mt-3">
                            <h1 class="ml-2">Residual Risk</h1>
                            <div class="border-b border-solid mt-3 border-lightgrey"></div>
                            <div class="row flex flex-row w-full">
                                <div class="col-md-6 w-6/12 p-2">
                                    <label class="controllabel">Security Level</label>
                                    <!-- <select
                                        class="disabledinputboxstyling"
                                        disabled
                                        v-model="mainResiudalRisk"
                                    >
                                        <option value="" selected disabled hidden>Please select one</option>
                                        <option v-for="obj in dbSeverity" :key="obj" :value="obj.value">{{obj.key}}</option>
                                    </select> -->
                                    <Select
                                        v-model="mainResiudalRisk"
                                        :options="dbSeverity"
                                        disabled
                                        optionLabel="key"
                                        optionValue="value"
                                        placeholder="Please select one"
                                        class="custom-multiselect w-full"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
            <div class="border-b border-solid border-lightgrey mx-1 mt-3 mb-2"></div>
            <div class="buttonposition flex justify-end items-center mt-3 mb-2 mx-5">
                <button class="btnprimary mr-1.5" @click="cancelRisk()" :class="disableStatus?'btndisabled pointer-events-none':'btnprimary'">Reset</button>
                <button class="btnprimary" @click="mitigateRisk()" :class="disableStatus?'btndisabled pointer-events-none':'btnprimary'">Mitigate</button>
            </div>
            </div>
            </div>

        </div>
            
    </div>
    
</template>
<style scoped>

</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { required,helpers,requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { toast } from '../../main';
import breadCrumb from '@/components/breadCrumb.vue';
import { mapGetters } from 'vuex';
import Select from 'primevue/select';
export default defineComponent({
    data(): any {
        return {
            // v$: useVuelidate(),
            systems:[],
            incomingRisksArray:[],
            optionsUserArray:[],
            mainImpact:'',
            mainLikelihood:'',
            mainResiudalRisk:'',
            insertedIds:[],
            controlIds:[],
            riskObj:{
                legal:'',
                operations:'',
                financial:'',
                business:'',
                likelihood:'',
            },
            mainRisk:{},
            mitigatePayloadForRisk:'',
            linkedSystemsArray:[],
            dummy:{},
            routesArray:[],
        };
    },
    components: {
        breadCrumb,
        Select
    },
    async mounted() {
        await this.getSystems();

        let data:any = localStorage.getItem(this.$route.params.riskId);
        this.linkedSystemsArray = JSON.parse(data);
        await this.getAllSystemsRisks();

        this.getMaxImpactValue();
        this.getMaxResidualRiskValue();

        const Mitigate:any = localStorage.getItem('MITIGATE_DATA');
        this.mitigatePayloadForRisk = JSON.parse(Mitigate);

        if(Object.keys(this.$route.query).includes('risks')){
            this.routesArray = [{name:'Risks',routeName:'risks'},{ name:'Tier-Risks',routeName:'systemRisk', id:this.$route.params.riskId},{name:'Risk-Mitigate',routeName:'riskMitigate'}];

            // this.routesArray = [{name:'Risks',routeName:'risks'},
            // {name:'System-Risk',routeName:'systemRisk',id:this.$route.params.riskId},
            // // {name:'Risk-Mitigate',routeName:'systemsControlsMapWithId',riskId:this.$route.params.riskId,systemRiskId:this.$route.params.systemRiskId},
            // {name:'Residual-Risk',routeName:'residualRisk'}];
        }else if(Object.keys(this.$route.query).includes('systems')){
            this.routesArray = [
                { name: 'Systems', routeName: 'systems' },
                { name: 'System-Information', routeName: 'systemInformation', id: this.$route.params.id},
                // {name:'Risk-Mitigate',routeName:'systemsControlsMapWithId',riskId:this.$route.params.riskId,systemId:this.$route.params.systemId},
                {name:'Residual-Risk',routeName:'residualRisk'}
            ];
        }else if(Object.keys(this.$route.query).includes('process')){
            this.routesArray = [
                { name: 'Business Process', routeName: 'businessProcess' },
                { name: 'Process-Information', routeName: 'processInformation', id: `${ this.$route.params.id}` },
                {name:'Risk-Mitigate',routeName:'riskMitigate'}
            ];
        }else if(Object.keys(this.$route.query).includes('organization')){
            this.routesArray = [
                { name: 'Organization', routeName: 'organization' },
                { name: 'Organization-Information', routeName: 'worklogFromOrganization', id: `${ this.$route.params.id }` },
                {name:'Risk-Mitigate',routeName:'riskMitigate'}
            ];
        }
    },
  
    computed: {
        ...mapGetters({ userInfo: 'userInfo',dbSeverity:'dbSeverity',dbLikelihood:'dbLikelihood',dbBussiness:'dbBussiness',
            dbOrganization:'dbOrganization',dbOperations:'dbOperations',dbLegal:'dbLegal',
            dbFinancial:'dbFinancial',dbTechnical:'dbTechnical',dbProcessCriticality:'dbProcessCriticality',
            dbAvailability:'dbAvailability',dbConfidentiality:'dbConfidentiality',dbIntegrity:'dbIntegrity',
            dbInformationClassification:'dbInformationClassification',dbSecurityCategory:'dbSecurityCategory',dbPriority:'dbPriority' }),

        disableStatus: function (): any {
            let disableStatusCondition;
            if (JSON.stringify(this.riskObj) == JSON.stringify(this.dummy)) {
                disableStatusCondition = true;
            } else {
                disableStatusCondition = false;
                }
            return disableStatusCondition;
        },
    },
    methods: {
        getMaxImpactValue(){
            let averageImpact = Math.round(this.average([this.riskObj.business, this.riskObj.operations, this.riskObj.legal, this.riskObj.financial]));
            
            this.mainImpact = averageImpact;
            this.getMaxResidualRiskValue();
        },
        average(arr: any) {
            return arr.reduce((p: any, c: any) => p + c, 0) / arr.length;
        },
        getMaxResidualRiskValue(){
            if(this.mainImpact != ''){
                this.mainResiudalRisk = this.riskResidual(this.riskObj.likelihood * this.mainImpact);
            }         
        },
        riskResidual(value: number) {
            if (value <= 3) {
                return 1;
            } else if (value > 3 && value <= 8) {
                return 2;
            } else if (value > 8 && value <= 12) {
                return 3;
            } else if (value > 12 && value <= 16) {
                return 4;
            } else if (value > 16 && value <= 25) {
                return 5;
            }
        },
        cancelRisk(){
            this.riskObj = {...this.dummy};
            this.getMaxImpactValue();
            
        },
        async mitigateRisk(){       
            this.linkedSystemsArray.map((system:any)=>{
                let present = this.incomingRisksArray.find((obj:any)=>{return obj.systemId == system});                
                // Object.keys(this.riskObj).map((key:any)=>{
                //     present[key] = this.riskObj[key]
                // })
                // console.log('rrrrrrrrrrrrrrrr',present);
                
                // this.updateRisk(present);
            })  
            await this.activateControlsForMitigate(this.mitigatePayloadForRisk)
            // await this.createWorkFlowTask(this.mitigatePayloadForRisk); 
        },
        async getSystems() {
             let entityId='20005'
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${entityId}`).then((result: any) => {
                this.systems = result.data;
            });
        },
        async activateControlsForMitigate(mitigateData:any){
            let payload:any=[];
            if(this.mainRisk.processId){
                payload = mitigateData[0].mappedControls.map((item: any) => {
                return {
                    activityId: item.process?.[0],
                    controls: item.controls || [],
                    updatedAt: new Date().toISOString(),
                    updatedBy: this.userInfo._id // or wherever you store it
                };
                });
            }
            else if(this.mainRisk.systemId){
                payload = mitigateData[0].mappedControls.map((item: any) => {
                return {
                    systemId: item.systems?.[0],
                    controls: item.controls || [],
                    updatedAt: new Date().toISOString(),
                    updatedBy: this.userInfo._id // or wherever you store it
                };
                });
            }
            
            await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/check/controls/active`, payload).then(async (result: any) => {
                    let data = result.data;                  
                    const controls = [
                        ...(result.data.newlyAddeddControls || []),
                        ...(data.activatedControls || []),
                        ...(data.existingControls || [])
                        ].filter(v => v != null);
                    
                        if (controls.length > 0) {
                        this.controlIds.push(...controls);
                        }
                    
                    await this.createWorkFlowTask(this.controlIds);
                    
                });
            

            
        },

        //change
        async getAllSystemsRisks(){
            await this.$http.get(`${process.env.VUE_APP_RISK_API}/api/org/risk/${this.$route.params.riskId}/systems`).then((result: any) => {
                this.incomingRisksArray = result.data;
                if(Object.keys(this.$route.query).includes('systems')){
                    this.mainRisk = this.incomingRisksArray.find((obj:any)=>{return obj.systemId == this.$route.params.id});
                }else if(Object.keys(this.$route.query).includes('process')){
                    this.mainRisk = this.incomingRisksArray.find((obj:any)=>{return obj.processId == this.$route.params.id});
                }else if(Object.keys(this.$route.query).includes('organization')){
                    this.mainRisk = this.incomingRisksArray.find((obj:any)=>{return obj.orgId == this.$route.params.id});
                }
                
                Object.keys(this.riskObj).map((key:any)=>{
                    this.riskObj[key] = this.mainRisk[key]
                });
                this.dummy = {...this.riskObj}
            })
        },

        async updateRisk(object:any){
            try {
                let riskId = object._id;
                delete object._id;
                await this.$http.post(`${process.env.VUE_APP_RISK_API}/api/root/risk/${riskId}/update?org==true`, object).then((result: any) => {
                    
                });
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
            await this.getAllSystemsRisks();
        },
        async createTask(payload:any,controls:any,insertedTasks:any) {
            if(JSON.stringify(this.riskObj) != JSON.stringify(this.dummy)){
                payload[0].residual = [this.riskObj];
                payload[0].residual[0].isActive = false;
                payload[0].updatedBy = this.userInfo._id;
                payload[0].updatedAt = new Date();
            }else{
                payload[0].residual = [];
            }
            const formattedControls = controls.map((id:any) => ({
                controlId: id,
                weightage: 0
                }));
            let riskData:any;
            
            if(this.$route.params.type=='process'){
                riskData={
                activities:[this.$route.params.id],
                tier:2,
                createdBy:this.userInfo._id,
                createdAt: new Date(),
                treatmentType:10405,
                action:10405,
                riskId:this.mainRisk._id,
                insertedIds:[...insertedTasks],
                residual:[this.riskObj],
                controls:formattedControls
            }
            }
            else if(this.$route.params.type=='system'){
                riskData={
                systems:[this.$route.params.id],
                tier:3,
                createdBy:this.userInfo._id,
                createdAt: new Date(),
                treatmentType:10405,
                action:10405,
                riskId:this.mainRisk._id,
                insertedIds:[...insertedTasks],
                residual:[this.riskObj],
                controls:formattedControls
                }
            }
            try {
                let actionName:any='mitigate';
                await this.$http.post(`${process.env.VUE_APP_RISK_API}/risk/${actionName}`, [riskData]).then((result: any) => {
                    toast.info('Mitigated', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                    localStorage.removeItem('MITIGATE_DATA');
                    localStorage.removeItem(this.$route.params.riskId);
                    
                    if(Object.keys(this.$route.query).includes('risks')){
                        let name:any
                        if(Object.keys(this.$route.query).includes('systems')){
                            name ='systemRisks'
                        } else if(Object.keys(this.$route.query).includes('process')){
                            name ='processRisks'
                        } else if(Object.keys(this.$route.query).includes('organization')){
                            name ='orgRisks'
                        } 
                        this.$router.push({ name: 'tierRisks', params: { riskId: this.$route.params.riskId, type:name } });

                    }else if(Object.keys(this.$route.query).includes('systems')){
                        this.$router.push({ name: 'systems' });

                    } else if(Object.keys(this.$route.query).includes('process')){
                        this.$router.push({ name: 'processInformation', params: { processId: payload[0].mappedControls[0].process[0] } });

                    } else if(Object.keys(this.$route.query).includes('organization')){
                        this.$router.push({name: 'organizationInformation', params: { orgId: payload[0].mappedControls[0].org[0] }});

                    } 
                });
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
         async createWorkFlowTask(controlIds:any){
            try {
                let payload:any={
                    mappedControls : controlIds,
                    linkedRiskId:this.mainRisk._id,
                    residual:this.riskObj
                }                
                
                await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,payload).then((result: any) => {                    
                    this.insertedIds = result.data
                    
                });
                // this.mitigatePayloadForRisk[0].insertedIds = this.insertedIds;
                await this.createTask(this.mitigatePayloadForRisk,payload.mappedControls,this.insertedIds)
            } catch (e) {
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
    }
});
</script>



